export default `float de( vec3 p ){
  p = abs( p );
  p += p.yzx;
  return ( max( max( p.x, p.y ), p.z ) - 1.0 ) * sqrt( 0.5 );
}`